import React from "react";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import { Button } from "../../design-system";

/**
 * Shared CSV/PDF toolbar control — same look as {@link CsvDown} / {@link CsvDownApi} / {@link PdfDownApi}
 * (outline, sm, download icon, loading state).
 */
export default function ExportToolbarButton({
  children = "Download CSV",
  loading = false,
  disabled = false,
  onClick,
  type = "button",
  ...rest
}) {
  return (
    <Button
      type={type}
      variant="outline"
      size="sm"
      disabled={disabled}
      loading={loading}
      loadingKeepText
      leftIcon={<DownloadOutlinedIcon sx={{ fontSize: 16 }} />}
      onClick={onClick}
      {...rest}
    >
      {loading ? "Please wait..." : children}
    </Button>
  );
}
